(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-intro"] && !Shopify.designMode) return;
  try {
    
  // Progressive enhancement: the intro renders in full, then collapses only if
  // it genuinely overflows. Collections whose intro is already short are left
  // alone and never show a toggle.
  (() => {
    const setup = (root) => {
      const text = root.querySelector('[data-collapsible]');
      const toggle = root.querySelector('.collection-intro__toggle');
      if (!text || !toggle || root.dataset.introReady === 'true') return;

      const limit = parseInt(getComputedStyle(text).getPropertyValue('--intro-collapsed-height'), 10) || 96;
      if (text.scrollHeight <= limit + 8) return;

      root.dataset.introReady = 'true';
      text.classList.add('is-collapsed');
      toggle.hidden = false;

      toggle.addEventListener('click', () => {
        const open = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!open));
        text.classList.toggle('is-collapsed', open);
      });
    };

    const init = () => document.querySelectorAll('.collection-intro__inner').forEach(setup);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
